/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useState, useEffect } from "react";
import "./index.scss";

import { Modal } from "antd";

// components
import Banner from "./Banner";
import IntroducingPrecog from "./IntroducingPrecog";
import Automated from "./Automated";
import ProjectRoadmap from "./ProjectRoadmap";
import PrecogTeam from "./PrecogTeam";
import Token from "./Token";
import Structured from "./Structured";
// import Community from "./Community";
import ContactUs from "./ContactUs";
import FAQs from "./FAQs";
import JoinMailing from "./JoinMailing";
import Header from "../Layouts/Header";
import Footer from "../Layouts/Footer";
import Sentient from "./Sentient";
// import Products from "./Products";
// import JoinOurMailingForm from "./JoinOurMailingForm";
import Socials from "common/Socials";
import MailchimpFormContainer from "common/MailChimp/MailchimpSubscribe";

import CloseIcon from "assets/icons/close-red.svg";

const LandingContent = (props) => {
  const roadMapRef = useRef(null);
  const homeRef = useRef(null);
  const productsRef = useRef(null);
  const teamRef = useRef(null);
  const tokenRef = useRef(null);
  const faqRef = useRef(null);
  const lightRef = useRef(null);
  const contactRef = useRef(null);
  const buyTokenRef = useRef(null);
  const introRef = useRef(null);
  const sentientRef = useRef(null);

  const prevScrollY = useRef(0);
  const [goingUp, setGoingUp] = useState(false);
  const [open, setOpen] = useState(true);

  const handleViewContentWithMenu = (ref) => {
    ref.current.scrollIntoView();
  };

  // useEffect(() => {
  //   let isVisited = localStorage.getItem("isVisited");
  //   if (!isVisited) {
  //     setOpen(true);
  //   }
  // }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (prevScrollY.current < currentScrollY && goingUp) {
        setGoingUp(false);
      }
      if (prevScrollY.current > currentScrollY && !goingUp) {
        setGoingUp(true);
      }

      if (currentScrollY < 85) {
        setGoingUp(false);
      }

      prevScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [goingUp]);

  const handleTogglePopup = () => {
    setOpen(!open);
    // localStorage.setItem("isVisited", true);
  };

  return (
    <div className="landingPage" ref={homeRef}>
      <Header
        onView={handleViewContentWithMenu}
        homeRef={homeRef}
        productsRef={productsRef}
        teamRef={teamRef}
        tokenRef={tokenRef}
        faqRef={faqRef}
        lightRef={lightRef}
        contactRef={contactRef}
        buyTokenRef={buyTokenRef}
        showHeader={goingUp}
      />

      {/* <MailchimpFormContainer /> */}

      <div className="landingContent">
        <Socials className="landingSocials" />
        <Banner />
        <IntroducingPrecog productsRef={productsRef} introRef={introRef} />
        {/* <Products
          productsRef={productsRef}
          sentientRef={sentientRef}
          introRef={introRef}
        /> */}
        <Sentient sentientRef={sentientRef} />

        <Automated />
        <ProjectRoadmap roadMapRef={roadMapRef} />
        <PrecogTeam teamRef={teamRef} />
        <Token tokenRef={tokenRef} />
        <Structured />
        {/* <Community /> */}
        <ContactUs contactRef={contactRef} />
        <FAQs faqRef={faqRef} />
        <JoinMailing />
      </div>

      {open && (
        <Modal
          wrapClassName="modalJoin"
          centered
          title={null}
          footer={null}
          closable={null}
          visible={open}
          onOk={handleTogglePopup}
          onCancel={handleTogglePopup}
        >
          <a className="btnCloseModal" onClick={handleTogglePopup}>
            <img alt="" src={CloseIcon} />
          </a>
          {/* <JoinOurMailingForm /> */}
          <MailchimpFormContainer onClose={handleTogglePopup} />
        </Modal>
      )}

      <Footer />
    </div>
  );
};

export default LandingContent;
